"use client";

import BaseIndicatorConfig from "../common/BaseIndicatorConfig";

interface ADXConfigProps {
  indicator: Parameters<typeof BaseIndicatorConfig>[0]["indicator"];
  onBack: () => void;
  onApply: (indicator: any) => void;
  isEditing?: boolean;
}

export default function ADXConfig({
  indicator,
  onBack,
  onApply,
  isEditing,
}: ADXConfigProps) {
  return (
    <BaseIndicatorConfig
      indicator={indicator}
      onBack={onBack}
      onApply={onApply}
      isEditing={isEditing}
      defaultExpandedStyle="adx"
    />
  );
}
